export default function detectKeyboardUser(event) {
  if (event.keyCode === 9) {
    document.body.classList.add("userIsTabbing");
    window.removeEventListener("keydown", detectKeyboardUser);
  }
}
